export default "__VITE_ASSET__CPQZHfrZ__"